import { createSlice } from '@reduxjs/toolkit';


export const userInfoSlice = createSlice({
    name : 'userInfo',
    initialState : {
        schoolName : '',
        branch : '',
        loggedinUser : '',
        email: '',
        userRole: '',
        school_id: '',
        user_id: null
    },
    reducers:{
        // Data is getting from PrivateRoute.js file

        userSchool(state,action){
            state.schoolName = action.payload
        },

        usersBranch(state,action){
            state.branch = action.payload
        },

        usersEmail(state,action){
            state.email = action.payload
        },

        loggedinUser(state,action){
            state.loggedinUser = action.payload
        },

        user_role(state,action){
            state.userRole = action.payload
        },

        user_school_id(state,action){
            state.school_id = action.payload
        },

        logged_user_id(state,action){
            state.user_id = action.payload
        },
    }
})

export const { userSchool, usersBranch, usersEmail, loggedinUser, user_role, user_school_id, logged_user_id } = userInfoSlice.actions
export default userInfoSlice.reducer